import React from 'react';

import SelectInput from '@common_components/inputs/selects/selectInput.component';
import type { AdditionalIndicatorSectionProps } from './chartSectionList.interfaces';

const GAUGE_TYPES: string[] = [ 'progress_gauge', 'custom_gauge', 'auto_increment_gauge' ];

const AdditionalIndicatorSection: React.FC<AdditionalIndicatorSectionProps> = ( {
  t: translate,
  newSetting,
  onChangeField,
  fetchHistoryOptions,
} ) => {
  const isGauge = GAUGE_TYPES.includes( newSetting.type );

  return (
    <>
      <div className="col-span-2 mt-1">
        <p className="text-[11px] font-semibold text-gray-700 mb-1">
          {translate( 'translation:additional_indicator_section' )}
        </p>
        <hr className="border-gray-200 mb-2" />
        { isGauge && (
          <p className="text-[11px] text-gray-400 italic">
            {translate( 'translation:no_additional_indicator_for_gauge' )}
          </p>
        ) }
      </div>
      { !isGauge && (
        <SelectInput
          className="w-full"
          label={translate( 'translation:history' ) as string}
          tooltip={translate( 'translation:history_tooltip' ) as string}
          labelPosition="top"
          fetchOptions={fetchHistoryOptions}
          selected={newSetting.additionalIndicator}
          onSelect={val => { return onChangeField( 'additionalIndicator', val ); }}
        />
      ) }
    </>
  );
};

export default AdditionalIndicatorSection;
